import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, useRedirect, TopToolbar, CreateButton, ExportButton, Button, SearchInput, useResourceContext, Filter, TextInput, FilterButton, ListActions, useListContext } from "react-admin";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Link, useLocation } from "react-router-dom";
import { formatPhoneNumberStrict, formatPostalCode, getResourceName } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FilterableHeader, { CustomerFilters } from "./FilterableHeaderWithPopover";
import FilterToggleHeader from "./FilterableHeaderWithPopover";
import FilterableHeaderWithPopover from "./FilterableHeaderWithPopover";
import Box from '@mui/material/Box';
import { InitialFilterTabs } from "../components/InitialFilterTabs";

const CustomersList = () => {
  const redirect = useRedirect();
  const [customerPath, setCustomerPath] = useState(null);
  const location = useLocation();
  const resource = useResourceContext(); 
  const [serchText, setSearchText] = useState(null);
  const [isTop, setIsTop] = useState(false);

  useEffect(() => {
    const pathParts = location.pathname.split("-");
    const secondAndAfter = pathParts.slice(1).join("-"); // 2個目以降を結合
    setCustomerPath(secondAndAfter);
  }, [location.pathname]);

  const CustomersActions = () => {    
    return (
      <TopToolbar>
        {location.pathname === "/customers-inspect"  && <Button label="点検リスト" onClick={() => redirect(`/inspect`)} ><SwapHorizIcon /></Button>}
        <Button label="未収リスト" onClick={() => redirect(`/uncollect-${customerPath}`)} ><SwapHorizIcon /></Button>
        <CustomCreateButton basePath={location.pathname}/>
        <ExportButton />
      </TopToolbar>
    );
  };

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => ({
  //     "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //     "名前": `${record.surname ?? ""} ${record.name ?? ""}`, // フルネーム結合
  //     "会社名": record.companyName ?? "",
  //     "電話番号１": record.phone ? record.phone : "",
  //     "電話番号２": record.telephone ? record.telephone : "",
  //     "FAX": record.fax ? record.fax : "",
  //     "登録日": record.createDate ? new Date(record.createDate).toLocaleDateString() : "",
  //     "契約オーナー名": `${record.orner_surname ?? ""} ${record.orner_name ?? ""}`, // フルネーム結合
  //     "契約日": record.contractDate ? new Date(record.contractDate).toLocaleDateString() : "",     
  //   }));
  
  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `顧客一覧(${getResourceName(location.pathname)})_` + new Date().toLocaleDateString());
  // };

const customExporter = (records) => {
    const excelData = records.map(record => ({
      "名前": `${record.surname ?? ""} ${record.name ?? ""}`, // フルネーム
      "会社名": record.companyName ?? "",
      "電話番号１": record.phone ?? "",
      "電話番号２": record.telephone ?? "",
      "FAX": record.fax ?? "",
      "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`, 
      "登録日": record.createDate ? new Date(record.createDate).toLocaleDateString() : "",
      "契約オーナー名": `${record.orner_surname ?? ""} ${record.orner_name ?? ""}`,
      "契約日": record.contractDate ? new Date(record.contractDate).toLocaleDateString() : "",     
    }));

    // シート生成
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 列幅の指定（wch = width in characters）
    worksheet['!cols'] = [
      { wch: 15 }, // 名前
      { wch: 20 }, // 会社名
      { wch: 15 }, // 電話番号１
      { wch: 15 }, // 電話番号２
      { wch: 15 }, // FAX
      { wch: 60 }, // 住所
      { wch: 14 }, // 登録日
      { wch: 18 }, // 契約オーナー名
      { wch: 14 }, // 契約日
    ];

    // ワークブック作成
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "顧客一覧");

    // バッファに書き出し
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 保存
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `顧客一覧(${getResourceName(location.pathname)})_${new Date().toLocaleDateString()}.xlsx`);
  };

   const onSearch = (value) => {
    setSearchText(value);
  }


  const CustomerFilters = [
    <SearchInput
      source="q" 
      alwaysOn 
      // placeholder="郵便番号・住所・顧客名・オーナー名" 
      inputProps={{ style: { fontSize: '12px' } }} 
      sx={{ width: 300 }}
      onChange={onSearch}
      value={serchText}
    />,
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };


  const ListComponent = ({ isTop, setSearchText }) =>{
    const { setFilters, filterValues } = useListContext();

    const resetFilter = () => {
      // 第1引数: filters オブジェクトを空に
      // 第2引数: displayedFilters オブジェクトを空に
      setFilters({}, {});
      setSearchText(null);
    };

    useEffect(() => {
      if (isTop) {
        setFilters({}, {});
      }
    }, [isTop]);

    // フィルターがリセットされたことを検知
    useEffect(() => {
      const isEmpty = Object.keys(filterValues).length === 0 || 
                     (Object.keys(filterValues).length === 1 && !filterValues.q);
      
      if (isEmpty && isTop) {
        window.location.href = "/customer";
      }
    }, [filterValues]);
    return (
      <>
        <Button onClick={resetFilter}>
          フィルターをリセット
        </Button>
        <Box sx={{ display: 'flex', width: '100%' }}>
          {/* 左側：あかさタブ */}
          <Box component="nav">
            <InitialFilterTabs />
          </Box>

          {/* 右側：Datagrid は flex:1 で残り幅を占有 */}
          <Box sx={{ flex: 1 }}>
            <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} >
              <FunctionField label={<FilterableHeaderWithPopover source="bukken" label="物件名" />}
                render={record => {
                  return `${record.bukken ?? ""}`;
                }}
              />
              <FunctionField
                label={<FilterableHeaderWithPopover source="surname" label="顧客名" />}
                render={record => {
                  return `${record.surname ?? ""} ${record.name ?? ""}`;
                }}
              />
              {/* <TextField source="companyName" label="会社名" /> */}
              <FunctionField
                source="phone"
                label={<FilterableHeaderWithPopover source="phone" label="電話番号１" />}
                render={(record) => record.phone ?? ""}
                sortable={false}
              />
              <FunctionField
                source="telephone"
                label={<FilterableHeaderWithPopover source="telephone" label="電話番号２" />}
                render={(record) => record.telephone ?? ""}
                sortable={false}
              />
              <FunctionField
                source="fax"
                label={<FilterableHeaderWithPopover source="fax" label="FAX" />}
                render={(record) => record.fax ?? ""}
                sortable={false}
              />
              <FunctionField
                label={<FilterableHeaderWithPopover source="address" label="住所" />}
                render={record => {
                  return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
                }}
              />
              {/* <DateField source="createDate" label="登録日" /> */}
              {(location.pathname === "/customers-inspect" || location.pathname === "/customers-garbage-allow")  && 
                <FunctionField
                  label={<FilterableHeaderWithPopover source="orner_surname" label="オーナー名" />}
                  render={record => {
                    return `${record.orner_surname ?? ""} ${record.orner_name ?? ""}`;
                  }}
                />
              }
              {/* {(location.pathname === "/customers-inspect" || location.pathname === "/customers-garbage-allow")  && <DateField source="contractDate" label="契約日" />} */}
            </Datagrid>
          </Box>
        </Box>
      </>
    )
  }

  const handleBackToTop = () => {
    setIsTop(true);
    setSearchText(null);
  };

  return (
    <>
      <Button onClick={handleBackToTop} variant="contained" style={{ marginTop: "10px", width: "150px" }}>検索TOPに戻る</Button>
      <List actions={<CustomersActions />}  exporter={customExporter} filters={CustomerFilters} >
        <ListComponent isTop={isTop} setSearchText={setSearchText} />
      </List>
    </>
  );
};

export default CustomersList;
